<template>
  <Block class="course-outline-note this-block" lift>
    <div slot="header" class="-header">
      <div class="--title">
        <span>
          {{ subjectCode }} : {{ subjectNameLocal }}
        </span>
      </div>
    </div>

    <div class="-body">
      <div id="description">
        <span>
          {{ subjectDescription }}
        </span>
      </div>
    </div>

    <div class="-footer">
      <div id="teacher">
        <span>
          ผู้สอน {{ teacherFirstNameLocal + ' '
            + teacherLastNameLocal
          }}
          </span>
      </div>

      <div id="credit">
        <div class="credit-number">{{ subjectCreditCalGrade }}</div>
        <span>
          หน่วยกิต
        </span>
      </div>

    </div>
  </Block>
</template>

<script>
import { Block } from "@/components/common-ui";

export default {
  components: {
    Block
  },
  props: {
    subjectCode: String,
    subjectNameLocal: String,
    subjectDescription: String,
    subjectCreditCalGrade: Number,
    teacherFirstNameLocal: String,
    teacherLastNameLocal: String
  }
}
</script>

<style lang="scss" scoped>
@import 'common-scoped';

.this-block {
  // background: #ededed;
  & .-footer {
    background: #eaeaea;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
  }
}

#description {
  flex-grow: 3;
  & > span {
    font-size: 0.9rem;
  }
}

#teacher {
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  padding-left: 12px;
  width: 100%;
  & > span {
    font-size: 1.1rem;
    color: #170d0d;
  }
}

#credit {
  flex-grow: 1;
  // background: rgb(240, 240, 240);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;


  & > span {
    font-size: 1.1rem;
    color: black;
  }

  & .credit-number {
    font-size: 1.1rem;
    color: white;
    background: grey;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
  }
}
</style>
